<header class="hd" [class.hd--scrolled]="scrolled()">
  <div class="container hd__inner">
    <a routerLink="/" class="brand" (click)="closeMenu()" aria-label="Mechtron Water Services, home">
      <span class="brand__name">MECHTRON</span>
      <span class="brand__sub">WATER SERVICES</span>
    </a>

    <button type="button" class="hd__toggle" (click)="toggleMenu()"
            [attr.aria-expanded]="menuOpen()" aria-controls="primary-nav" aria-label="Toggle navigation">
      <span aria-hidden="true"></span><span aria-hidden="true"></span><span aria-hidden="true"></span>
    </button>

    <nav id="primary-nav" class="hd__nav" [class.is-open]="menuOpen()" aria-label="Primary">
      <a routerLink="/" fragment="process" (click)="closeMenu()">Process</a>
      <a routerLink="/" fragment="divisions" (click)="closeMenu()">Divisions</a>
      <a routerLink="/equipment" routerLinkActive="is-active" (click)="closeMenu()">Equipment</a>
      <a routerLink="/about" routerLinkActive="is-active" (click)="closeMenu()">About</a>
      <a routerLink="/contact-us" class="btn btn--primary btn--sm" (click)="closeMenu()">Contact us</a>
    </nav>
  </div>
</header>
